export const INTEGRATIONS_INDEX_TOUR = {
  id: "integrations_index",
  steps: [
    {
      element: '[data-tour="integrations-index-create"]',
      popover: {
        title: "Nova integração",
        description:
          "Integrações recebem webhooks quando eventos como pagamento, renovação ou cancelamento ocorrem.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="integrations-index-list"]',
      popover: {
        title: "Suas integrações",
        description:
          "Veja quais eventos cada integração está inscrita e se está ativa. Clique em \"Gerenciar\" para configurar o portal do cliente.",
        side: "top",
      },
    },
  ],
};
